/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module MessageItemsModule
 */

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { ITrustedHost } from 'generated-types';
import { TrustedHost } from 'object-types';

import {
    Component,
    Type,
} from '@angular/core';

import { withFullModalMixin } from 'ajs/js/utilities/mixins/with-full-modal.mixin';
import { IpAddrConfigItem } from 'ajs/modules/data-model/factories';

interface ITrustedHostConfig extends Omit<ITrustedHost, 'host'> {
    host: IpAddrConfigItem,
}

/**
 * @description Trusted Host Config Item.
 * @author Shahab Hashmi
 */
export class TrustedHostConfigItem extends withFullModalMixin(MessageItem)<ITrustedHostConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: TrustedHost,
            objectName: 'trustedHost',
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Method used to import lazy loaded modal component.
     */
    /* eslint-disable-next-line class-methods-use-this */
    public async getModalComponent(): Promise<Type<Component>> {
        const {
            HostHeaderModalComponent,
        } = await import(
            /* webpackChunkName: "trusted-host-profile-modal" */
            // eslint-disable-next-line max-len
            'ng/lazy-loaded-components/modals/trusted-host-profile-modal/host-header-modal/host-header-modal.component',
        );

        return HostHeaderModalComponent as Type<Component>;
    }

    /** @override */
    protected requiredFields(): string[] {
        return [
            'host',
        ];
    }
}
